/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerFeedMill } from '../../models/customer-feed-mill';
import { CustomerFeedMillDto } from '../../models/customer-feed-mill-dto';

export interface UpdateCustomerFeedMill$Params {
  customerFeedMillId: number;
      body: CustomerFeedMillDto
}

export function updateCustomerFeedMill(http: HttpClient, rootUrl: string, params: UpdateCustomerFeedMill$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFeedMill>> {
  const rb = new RequestBuilder(rootUrl, updateCustomerFeedMill.PATH, 'put');
  if (params) {
    rb.path('customerFeedMillId', params.customerFeedMillId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerFeedMill>;
    })
  );
}

updateCustomerFeedMill.PATH = '/api/customer/feedMill/{customerFeedMillId}';
